import { useCheckPermission } from "../../../hooks/useCheckPermission";
import { useRole } from "../../../redux/features/user";

// Computes whether the QueryBuilder's edit affordances should be enabled.
// Returns false when:
//   - The page is mounted in read-only mode (SavedSearchView), OR
//   - The rule is missing (still loading), OR
//   - The rule already has saved data (immutable after first run), OR
//   - The rule is ACTIVATED (immutable while live), OR
//   - The user has no EDIT_RULE permission and is not GRANT_ADMIN.
export function useCanEdit({ rule, readOnly = false }) {
  const hasEditPermission = useCheckPermission("EDIT_RULE");
  const role = useRole();

  if (readOnly) return false;
  if (!rule) return false;
  if (rule.hasSavedData === true) return false;
  if (rule.status === "ACTIVATED") return false;
  return hasEditPermission || role === "GRANT_ADMIN";
}
